import React from 'react';
import styled from 'styled-components';
import QuoteImg from '../../assets/icons/quote.svg';
import { InfoSlider } from '../../components';

const Info = () => {
  return (
    <>
      <InfoContainer>
        <Quote src={QuoteImg} />
        <InfoTextContainer>
          <InfoText>
            В 2019 году команда EnerGO установила свой первый терминал на
            территории Москвы, спустя год, в 2020, мы запустили пилотный проект
            с Московским метрополитеном и установили порядка 150 терминалов на
            станциях самого популярного транспортного узла в Москве.
          </InfoText>
          <InfoText>
            В 2021 году официально подписали контракт на установку зарядных
            терминалов на каждой станции метро. В середине 2022 года, запущен
            проект с МФЦ, планируется установка более 130 станций с льготными
            тарифами.
          </InfoText>
          <InfoText>
            На данный момент мы установили более 4000 зарядных станций,
            привлекли более 1 000 000 активных пользователей, сформировали капитал
            в 290 000 000 рублей и не планируем на этом останавливаться!
          </InfoText>
        </InfoTextContainer>
        <InfoSlider />
      </InfoContainer>
    </>
  );
};

const InfoContainer = styled.div`
  display: flex;
  margin-top: 56px;
  align-items: flex-start;
  position: relative;
  margin-bottom: -24px;
  justify-content: space-between;
  @media (max-width: 1300px) {
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 599px) {
    margin-top: 46px;
    margin-bottom: -24px;
  }
`;

const InfoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 52%;
  @media (max-width: 1300px) {
    width: 100%;
  }
`;

const InfoText = styled.p`
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 16px;
  line-height: 32px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

const Quote = styled.img`
  position: absolute;
  top: -25px;
  left: -36px;
  opacity: 0.3;
  @media (max-width: 1135px) {
    top: -16px;
    left: -2.8%;
    opacity: 0.3;
    height: 47px;
  }
  @media (max-width: 599px) {
    top: 0px;
    left: -4.8%;
  }
`;

export default Info;
